import { publicApi } from './index';

export const appApi = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    checkAppUpdate: builder.mutation({
      query: ({ os, appVersion }) => ({
        url: '/app/update',
        method: 'POST',
        body: {
          os,
          appVersion,
        },
      }),
    }),
  }),
});

export const { useCheckAppUpdateMutation } = appApi;
